/* Čapkov "Doprava a platba" r2 (4. 10.): přepínač osy, jízda dodávky, živý termín doručení, detail kroků. Bez závislostí, defer.
   Kalendář (pražský čas, svátky, pracovní dny) = stejná logika jako assets/capkov-rd-pdp2.js (zkopírováno, PDP soubor se needituje).
   Režimy: cs / en (capkov.cz, uzávěrka z nastavení) a eu (capkov.com: jen "odešleme do 1–2 prac. dnů", bez uzávěrky a bez slibu "zítra"). */
(function () {
  'use strict';
  var root = document.querySelector('[data-rdp]');
  if (!root) return;
  var DAY = 86400000, MODE = root.getAttribute('data-mode') || 'cs', EU = MODE === 'eu', CS = MODE === 'cs';
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SAT = root.getAttribute('data-sat') === 'true', DE = root.getAttribute('data-de') === 'true';
  var DAYS = (root.getAttribute('data-days') || '1,2,3,4,5').split(',').map(function (x) { return parseInt(x, 10); });
  var CK = { stock: +root.getAttribute('data-ck-stock') || 16, custom: +root.getAttribute('data-ck-text') || 16 };
  var RT = window.RT || function (k, d) { return d; };
  /* cs/en: texty přes RT (česky výchozí, překlady z window.RD_T); eu = jen angličtina (EU motiv) */
  var S = MODE === 'eu' ? { today: 'today', tmr: 'tomorrow', now: 'You order now', at: 'ships by', by: '', left: '', ship: '', min: 'min', de: 'at your door', deSub: 'Germany: usually 3–4 business days', other: 'Delivery time depends on your country and carrier.', sub: 'We ship within 1–2 business days, usually the next business day.' } : {
      today: RT('n.e357a11', 'dnes'),
      tmr: RT('n.7dea176', 'zítra'),
      now: RT('n.31142fd', 'Objednáš teď'),
      at: RT('n.d271126', 'u tebe'),
      by: RT('n.e59c434', 'Objednáš do {0}:00 a odešleme ještě dnes'),
      left: RT('n.5c89f9e', ' · zbývá {0}'),
      ship: RT('n.ccbd3c8', 'Odesíláme {0}'),
      min: 'min'
  };
  var LNG = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
  var DL = CS ? 'cs-CZ' : (LNG && LNG !== 'en' ? document.documentElement.lang : 'en-GB');

  function pragueNow() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Prague', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' }), o = {};
    f.formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') o[p.type] = parseInt(p.value, 10); });
    return o;
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, mo - 1, da);
  }
  function holiday(t) {
    var dt = new Date(t), md = (dt.getUTCMonth() + 1) * 100 + dt.getUTCDate();
    if ([101, 501, 508, 705, 706, 928, 1028, 1117, 1224, 1225, 1226].indexOf(md) > -1) return true;
    var e = easter(dt.getUTCFullYear()); return t === e - 2 * DAY || t === e + DAY;
  }
  function iso(t) { var d = new Date(t).getUTCDay(); return d === 0 ? 7 : d; }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function ship(t) { return DAYS.indexOf(iso(t)) > -1 && !holiday(t); }
  function deliv(t) { return !holiday(t) && (iso(t) <= 5 || (SAT && iso(t) === 6)); }
  function next(t, fn) { var x = t + DAY; for (var i = 0; i < 20 && !fn(x); i++) x += DAY; return x; }
  function add(t, fn, k) { for (var i = 0; i < k; i++) t = next(t, fn); return t; }

  function calc(kind) {
    var cutoff = CK[kind], n = pragueNow(), today = Date.UTC(n.year, n.month - 1, n.day), secs = n.hour * 3600 + n.minute * 60 + n.second;
    var r = { cutoff: cutoff, today: today, now: pad(n.hour) + ':' + pad(n.minute) };
    if (EU) {
      var a = next(today, ship), b = next(a, ship);
      r.prod = [a, b]; r.arr = DE ? [add(today, deliv, 3), add(today, deliv, 4)] : null; r.before = false; return r;
    }
    var before = ship(today) && secs < cutoff * 3600, d0 = before ? today : next(today, ship);
    r.before = before; r.left = before ? cutoff * 3600 - secs : 0; r.d0 = d0;
    {
      r.prod = [d0, d0];
      var x = next(d0, deliv);
      r.arr = (x - d0 > DAY) ? [x, next(x, deliv)] : [x, x];
    }
    return r;
  }
  function short(t) { return window.RDD.shDate(t); }
  function dayShort(t, today) { var d = Math.round((t - today) / DAY); if (!EU && d === 0) return S.today; if (!EU && d === 1) return S.tmr; return short(t); }
  function dayWhen(t, today) {
    var d = Math.round((t - today) / DAY), dt = new Date(t);
    if (!EU && d === 0) return S.today; if (!EU && d === 1) return S.tmr;
    return window.RDD.en ? short(t) : window.RDD.onDate(t);
  }
  function rng(p, today, fn) { return p[0] === p[1] ? fn(p[0], today) : fn(p[0], today) + ' – ' + fn(p[1], today); }
  function left(s) { var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60); return h > 0 ? RT('n.6ee5a08', '{0}\u00a0h {1}\u00a0min').replace('{0}', h).replace('{1}', pad(m)) : RT('n.c363018', '{0}\u00a0min').replace('{0}', Math.max(m, 1)); }
  function fmt(s, v) { return s.replace('{0}', v); }

  var panels = [].slice.call(root.querySelectorAll('[data-pn]')), tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
  var resNow = root.querySelector('[data-res-now]'), resWhen = root.querySelector('[data-res-when]'), resSub = root.querySelector('[data-res-sub]');
  var det = root.querySelector('[data-det]'), cur = 'stock', userPicked = false, timers = [];

  function fill() {
    var r = calc(cur), t = r.today, when, sub = '';
    if (EU) {
      when = r.arr ? rng(r.arr, t, short) : rng(r.prod, t, short);
      if (resNow) resNow.textContent = S.now;
      var at = root.querySelector('[data-res-at]'); if (at) at.textContent = r.arr ? S.de : S.at;
      sub = r.arr ? S.deSub : (DE ? S.sub : S.other);
    } else {
      when = r.arr[0] !== r.arr[1] ? rng(r.arr, t, dayShort) : dayWhen(r.arr[0], t);
      if (r.before) sub = fmt(S.by, r.cutoff) + fmt(S.left, left(r.left));
      else sub = fmt(S.ship, dayWhen(r.d0, t));
    }
    if (resWhen && resWhen.textContent !== when) resWhen.textContent = when;
    if (resSub && resSub.textContent !== sub) resSub.textContent = sub;
  }

  function showDet(btn) {
    var pn = btn.closest('[data-pn]'); if (!pn || !det) return;
    pn.querySelectorAll('[data-step]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
    var tx = btn.getAttribute('data-tx') || ''; if (det.textContent !== tx) { det.classList.remove('is-in'); det.textContent = tx; void det.offsetWidth; det.classList.add('is-in'); }
  }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function play() {
    clearTimers(); root.classList.remove('is-play'); void root.offsetWidth;
    var pn = root.querySelector('[data-pn="' + cur + '"]'), steps = pn.querySelectorAll('[data-step]');
    showDet(steps[0]);
    if (REDUCED) { root.classList.add('is-play'); return; }
    requestAnimationFrame(function () {
      root.classList.add('is-play');
      var D = 2200;
      for (var i = 1; i < steps.length; i++) (function (i) { timers.push(setTimeout(function () { if (!userPicked) showDet(steps[i]); }, D * i / (steps.length - 1))); })(i);
      timers.push(setTimeout(function () { userPicked = false; }, D + 50));
    });
  }
  function select(k, focus, noplay) {
    if (k === cur && root.classList.contains('is-play')) return;
    cur = k; userPicked = false;
    tabs.forEach(function (b, i) { var on = b.getAttribute('data-tab') === k; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; if (on) { root.style.setProperty('--ti', i); if (focus) b.focus(); } });
    panels.forEach(function (pn) { var on = pn.getAttribute('data-pn') === k; pn.classList.toggle('is-on', on); pn.setAttribute('aria-hidden', on ? 'false' : 'true'); });
    fill(); if (!noplay) play(); else showDet(panels.filter(function (p) { return p.getAttribute('data-pn') === k; })[0].querySelector('[data-step]'));
  }
  tabs.forEach(function (b, i) {
    b.addEventListener('click', function () { select(b.getAttribute('data-tab')); });
    b.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
      e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length].getAttribute('data-tab'), true);
    });
  });
  root.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-step]'); if (b) { userPicked = true; showDet(b); } });
  root.addEventListener('mouseover', function (e) { var b = e.target.closest && e.target.closest('[data-step]'); if (b && !root.classList.contains('is-touch')) { userPicked = true; showDet(b); } });
  root.addEventListener('focusin', function (e) { var b = e.target.closest && e.target.closest('[data-step]'); if (b) { userPicked = true; showDet(b); } });
  root.addEventListener('touchstart', function () { root.classList.add('is-touch'); }, { passive: true, once: true });

  fill(); setInterval(function () { if (!document.hidden) fill(); }, 20000);
  select('stock', false, true);
  var stage = root.querySelector('[data-stage]');
  if (REDUCED || !('IntersectionObserver' in window)) play();
  else new IntersectionObserver(function (es, io) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); play(); } }); }, { threshold: .4 }).observe(stage || root);

  /* odkaz #sledovani-zasilky z e-mailů otevře správnou otázku */
  function openHash() { var h = location.hash && location.hash.slice(1); if (!h) return; var el = document.getElementById(h); if (el && el.tagName === 'DETAILS') el.open = true; }
  openHash(); window.addEventListener('hashchange', openHash);
})();
